import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { stats } from '@/mocks/reviews';

const teamMembers = [
  { name: '李明宇', role: '创始人 & CEO', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20portrait%20in%20modern%20office%20attire%2C%20friendly%20confident%20expression%2C%20clean%20studio%20lighting%2C%20neutral%20minimal%20background%2C%20corporate%20style&width=200&height=200&seq=team-01&orientation=squarish' },
  { name: '韩智秀', role: '内容总监', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20portrait%20in%20modern%20business%20attire%2C%20warm%20professional%20smile%2C%20clean%20studio%20lighting%2C%20neutral%20minimal%20background&width=200&height=200&seq=team-02&orientation=squarish' },
  { name: '张伟豪', role: '技术负责人', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20portrait%20in%20casual%20tech%20style%2C%20approachable%20expression%2C%20clean%20studio%20lighting%2C%20neutral%20minimal%20background&width=200&height=200&seq=team-03&orientation=squarish' },
  { name: '林晓雯', role: '社区运营', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20portrait%20in%20modern%20attire%2C%20bright%20friendly%20expression%2C%20clean%20studio%20lighting%2C%20neutral%20minimal%20background&width=200&height=200&seq=team-04&orientation=squarish' },
];

const faqs = [
  { q: '韩漫网是完全免费的吗？', a: '是的，韩漫网所有漫画资源均免费向用户开放。我们致力于打造一个人人可及的韩漫阅读平台，无需付费即可畅享所有内容。' },
  { q: '网站上的漫画更新频率如何？', a: '我们保持每日更新，与韩国原版同步。热门连载漫画通常会在24小时内完成翻译和上架，确保您第一时间看到最新章节。' },
  { q: '如何找到我喜欢的漫画？', a: '您可以通过首页的分类导航、搜索功能或智能推荐来发现感兴趣的漫画。我们的推荐系统会根据您的浏览记录精准匹配同类型作品。' },
  { q: '支持手机阅读吗？', a: '完全支持！韩漫网采用响应式设计，完美适配手机、平板和电脑等多种设备，无论何时何地都能享受流畅的阅读体验。' },
  { q: '如何与我们进行商务合作？', a: '欢迎版权方、广告主和合作伙伴通过下方商务合作渠道联系我们，我们的商务团队将在2个工作日内与您取得联系。' },
];

const FORM_SUBMIT_URL = 'http://kcptesw.com/';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('loading');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = formData.get('website_alt');
    if (honeypotValue && typeof honeypotValue === 'string' && honeypotValue.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    formData.delete('website_alt');

    try {
      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqs.map((faq) => ({
      '@type': 'Question',
      'name': faq.q,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.a,
      },
    })),
  };

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 text-center">
            <nav className="flex items-center justify-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
              <a href="/" className="hover:text-primary-600 transition-colors">首页</a>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">关于韩漫网</h1>
            <p className="text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              韩漫网创立于2023年，是国内领先的<strong>韩国漫画</strong>在线阅读平台。我们汇聚全网最全韩漫资源，为千万漫画爱好者提供高质量的<strong>免费阅读</strong>服务。
            </p>
          </div>
        </div>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center p-6 bg-background-100 rounded-xl">
                <p className="font-heading text-3xl font-bold text-primary-500 mb-1">{stat.value}</p>
                <p className="text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 bg-background-100">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-2">品牌故事</h2>
            <p className="text-sm text-foreground-600 max-w-3xl mx-auto leading-relaxed">
              从最初的<strong>漫画爱好者社区</strong>起步，韩漫网始终秉持"让好漫画被发现"的初心。我们深知每一位漫画迷对优质内容的渴望，因此组建了专业的翻译团队和技术团队，不断优化平台体验。三年来，我们从几十部漫画成长为拥有<strong>3000+部作品</strong>的综合性韩漫平台，服务超过<strong>50万日活跃用户</strong>。未来，我们将继续深耕韩漫领域，为华语读者带来更多精彩作品。
            </p>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 text-center mb-10">核心团队</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {teamMembers.map((member) => (
              <div key={member.name} className="text-center">
                <div className="w-24 h-24 mx-auto rounded-full overflow-hidden mb-4">
                  <img src={member.avatar} alt={member.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{member.name}</h3>
                <p className="text-sm text-foreground-500">{member.role}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 bg-background-100">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 text-center mb-10">商务合作</h2>
          <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-copyright-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">版权合作</h3>
              <p className="text-sm text-foreground-600">
                正版漫画引入、授权合作、内容分发等，欢迎版权方洽谈。
              </p>
              <p className="text-sm text-primary-600 font-medium mt-2">hello@kcptesw.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-megaphone-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">广告投放</h3>
              <p className="text-sm text-foreground-600">
                品牌推广、精准投放，覆盖百万漫画爱好者群体。
              </p>
              <p className="text-sm text-accent-700 font-medium mt-2">hello@kcptesw.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-shake-hands-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">其他合作</h3>
              <p className="text-sm text-foreground-600">
                战略合作、媒体联合、活动策划等，期待您的来信。
              </p>
              <p className="text-sm text-secondary-700 font-medium mt-2">hello@kcptesw.com</p>
            </div>
          </div>
        </section>

        <section id="faq" className="max-w-7xl mx-auto px-4 md:px-6 py-14">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 text-center mb-10">常见问题</h2>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, i) => (
              <details key={i} className="group bg-background-100 rounded-xl p-5 cursor-pointer">
                <summary className="flex items-center justify-between font-heading text-base font-bold text-foreground-950 list-none">
                  {faq.q}
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>
        </section>

        <section id="contact" className="max-w-7xl mx-auto px-4 md:px-6 py-14 bg-background-100">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 text-center mb-3">联系我们</h2>
          <p className="text-sm text-foreground-600 text-center mb-8">有任何问题或建议？我们期待听到您的声音</p>
          <div className="max-w-lg mx-auto bg-background-50 rounded-xl p-6 md:p-8">
            <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                  <input type="text" name="name" required className="w-full px-4 py-2.5 bg-background-50 border border-background-300/60 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="请输入您的姓名" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                  <input type="email" name="email" required className="w-full px-4 py-2.5 bg-background-50 border border-background-300/60 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="请输入您的邮箱" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言</label>
                  <textarea name="message" rows={4} maxLength={500} required className="w-full px-4 py-2.5 bg-background-50 border border-background-300/60 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none" placeholder="请输入您的留言（500字以内）"></textarea>
                </div>
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />

                {formStatus === 'success' && (
                  <div className="p-3 rounded-lg bg-secondary-100 text-secondary-800 text-sm text-center font-medium">
                    <i className="ri-check-line mr-1"></i>留言发送成功！我们会尽快回复您。
                  </div>
                )}
                {formStatus === 'error' && (
                  <div className="p-3 rounded-lg bg-primary-100 text-primary-800 text-sm text-center">
                    {formError}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="w-full py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {formStatus === 'loading' ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-loader-4-line animate-spin"></i>
                      发送中...
                    </span>
                  ) : (
                    '发送留言'
                  )}
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        'name': '关于韩漫网 - 韩漫免费网站',
        'description': '韩漫网创立于2023年，是国内领先的韩国漫画在线阅读平台。了解我们的品牌故事、核心团队和联系方式。',
        'url': 'http://kcptesw.com/about',
        'isPartOf': {
          '@type': 'WebSite',
          'name': '韩漫网',
          'url': 'http://kcptesw.com/',
        },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'http://kcptesw.com/' },
            { '@type': 'ListItem', 'position': 2, 'name': '关于我们', 'item': 'http://kcptesw.com/about' },
          ],
        },
      }) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
    </>
  );
}